import { handleProductImageError, resolveProductImage, resolveProductName } from '../utils/omp'
import { useDecodedImage } from '../hooks/useDecodedImage'
import { ImageSize } from '@/constants'

interface OmpProductImageProps {
  source: any
  size?: ImageSize
  useSubscription?: boolean
  alt?: string
  className?: string
}

// Single site for every product thumbnail in the portal. A shimmer holds the frame until the
// image is decoded (see useDecodedImage).
const OmpProductImage = ({
  source,
  size = ImageSize.Large,
  useSubscription = false,
  alt,
  className,
}: OmpProductImageProps) => {
  const src = resolveProductImage(source, useSubscription, size)
  const ready = useDecodedImage(src)

  if (!ready) {
    return <span className="skeleton omp-product-image-loading" aria-hidden="true" />
  }

  return (
    <img
      src={src}
      alt={alt ?? resolveProductName(source)}
      className={className}
      decoding="sync"
      fetchpriority="high"
      onError={e => handleProductImageError(e, source, useSubscription)}
    />
  )
}

export default OmpProductImage
